import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { useProfile } from "../../../context/ProfileContext";
import { LayoutBaseDePagina } from "../../../shared/layouts"; // Layout do projeto
import { BilletCardTab } from "./tabs/BilletCardTab";
import { BlockInvoiceTab } from "./tabs/BlockInvoiceTab";
import { CreditCardTab } from "./tabs/CreditCardTab";
import { FinancialHealthListTab } from "./tabs/ManagerCardTab";
import { NFSETab } from "./tabs/NfseTab";

export const FinancialPresentation = () => {
	const { isSuperAdmin } = useProfile();
	const canAccessBlocksMenu = isSuperAdmin || checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.BlockMenuView);
	const tabs = useMemo(
		() => [
			{ label: "Cartão de Crédito", content: <CreditCardTab /> },
			{ label: "Faturamento", content: <BilletCardTab /> },
			{ label: "Boletos", content: <FinancialHealthListTab /> },
			{ label: "Notas Fiscais", content: <NFSETab /> },
			...(canAccessBlocksMenu ? [{ label: "Bloqueios", content: <BlockInvoiceTab /> }] : []),
		],
		[canAccessBlocksMenu]
	);
	const [selectedTab, setSelectedTab] = useState(1); // Estado para gerenciar a tab selecionada

	useEffect(() => {
		if (selectedTab >= tabs.length) {
			setSelectedTab(0);
		}
	}, [selectedTab, tabs.length]);

	// Função para controlar a mudança de tab
	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setSelectedTab(newValue);
	};

	return (
		<LayoutBaseDePagina titulo="Financeiro" subtitulo="Controle de Faturamento, Cartão de Crédito e Boletos" barraDeFerramentas={<></>}>
			<Tabs
				value={selectedTab}
				onChange={handleTabChange}
				aria-label="Financeiro"
				sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper", mx: 1, borderRadius: 1, bordercolor: "divider" }}
			>
				{tabs.map((tab) => (
					<Tab key={tab.label} label={tab.label} />
				))}
			</Tabs>

			<Box sx={{ pt: 1 }}>{tabs[selectedTab]?.content ?? null}</Box>
		</LayoutBaseDePagina>
	);
};
